// The persistent game session — GameState outlives individual scenes (scenes are
// disposable; module state is not). Title starts/continues; Play mutates it.
import { GameState } from './state.js';

export let state = new GameState();

export function newGame(): void {
  state = new GameState();
  state.refreshOffered();
}

export function hasProgress(): boolean {
  return state.day > 1 || state.craftsmanship > 0 || state.workbenchBuilt || state.requestsDone > 0;
}
